import useAppState from "@dashboard/hooks/useAppState";
import { LinearProgress } from "@material-ui/core";
import { Box } from "@saleor/macaw-ui-next";
import type * as React from "react";

import { DevModePanel } from "../DevModePanel/DevModePanel";
import NavigatorSearch from "../NavigatorSearch";
import { useSavebarRef } from "../Savebar/SavebarRefContext";
import { Sidebar } from "../Sidebar";
import { SidebarProvider } from "../Sidebar/SidebarContext";
import { AppHeader } from "./AppHeader";
import { useStyles } from "./styles";

interface AppLayoutProps {
  children: React.ReactNode;
  fullSize?: boolean;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const classes = useStyles();
  const { setAnchor } = useSavebarRef();
  const [appState] = useAppState();

  return (
    <SidebarProvider>
      <DevModePanel />
      <NavigatorSearch />

      <Box display="grid" __gridTemplateColumns="auto 1fr">
        {appState.loading && <LinearProgress className={classes.appLoader} color="primary" />}
        <Box
          height="100vh"
          borderColor="default1"
          borderRightWidth={1}
          backgroundColor="default2"
          borderStyle="solid"
          position="sticky"
          top={0}
          borderLeftWidth={0}
          borderTopWidth={0}
          borderBottomWidth={0}
        >
          <Sidebar />
        </Box>
        <Box
          height="100vh"
          width="100%"
          overflow="hidden"
          display="flex"
          flexDirection="column"
        >
          <AppHeader />
          <Box as="main" width="100%" __flex="1" overflow="auto">
            {children}
          </Box>
          <Box
            ref={setAnchor}
            position="sticky"
            bottom={0}
            left={0}
            right={0}
            backgroundColor="default1"
            borderTopWidth={1}
            borderTopStyle="solid"
            borderColor="default1"
            zIndex="2"
          />
        </Box>
      </Box>
    </SidebarProvider>
  );
};

export default AppLayout;
